import {type TranslationObject} from '@colonist/i18n'

export interface FriendOnlineStatus {
    isOnline: boolean
    lastOnlineDate?: Date | undefined
    activity?: OnlineStatusActivityEnum | undefined
    roomId?: string
}

export interface ExistingFriendInterface {
    username: string
    onlineStatus: FriendOnlineStatus
}

export enum OnlineStatusActivityEnum {
    PlayingCitiesAndKnights4P = 'Playing Cities & Knights 4P',
    PlayingCitiesAndKnights56P = 'Playing Cities & Knights 5-6P',
    PlayingCitiesAndKnightsSeafarers4P = 'Playing SF + C&K 4P',
    PlayingCitiesAndKnightsSeafarers56P = 'Playing SF + C&K 5-6P',
    PlayingClassic4P = 'Playing Base Game 4P',
    PlayingClassic5678P = 'Playing Base Game 5-6P',
    PlayingSeafarers4P = 'Playing Seafarers 4P',
    PlayingSeafarers56P = 'Playing Seafarers 5-6P',
    InPrivateRoom = 'In Private Room',
    InPublicRoom = 'In Public Room',
    IsOnlineAndIdle = 'Idle',
}

export function getOnlineStatusActivityText(activity?: OnlineStatusActivityEnum): TranslationObject {
    if(activity == undefined) return {key: 'strings:colonistCommon.utils.emptyString'}

    switch(activity) {
        case OnlineStatusActivityEnum.PlayingCitiesAndKnights4P: return {key: 'strings:profilePage.statusActivity.playingCitiesAndKnights4P'}
        case OnlineStatusActivityEnum.PlayingCitiesAndKnights56P: return {key: 'strings:profilePage.statusActivity.playingCitiesAndKnights56P'}
        case OnlineStatusActivityEnum.PlayingCitiesAndKnightsSeafarers4P: return {key: 'strings:profilePage.statusActivity.playingCitiesAndKnightsSeafarers4P'}
        case OnlineStatusActivityEnum.PlayingCitiesAndKnightsSeafarers56P: return {key: 'strings:profilePage.statusActivity.playingCitiesAndKnightsSeafarers56P'}
        case OnlineStatusActivityEnum.PlayingClassic4P: return {key: 'strings:profilePage.statusActivity.playingClassic4P'}
        case OnlineStatusActivityEnum.PlayingClassic5678P: return {key: 'strings:profilePage.statusActivity.playingClassic5678P'}
        case OnlineStatusActivityEnum.PlayingSeafarers4P: return {key: 'strings:profilePage.statusActivity.playingSeafarers4P'}
        case OnlineStatusActivityEnum.PlayingSeafarers56P: return {key: 'strings:profilePage.statusActivity.playingSeafarers56P'}
        case OnlineStatusActivityEnum.InPrivateRoom: return {key: 'strings:profilePage.statusActivity.inPrivateRoom'}
        case OnlineStatusActivityEnum.InPublicRoom: return {key: 'strings:profilePage.statusActivity.inPublicRoom'}
        case OnlineStatusActivityEnum.IsOnlineAndIdle: return {key: 'strings:profilePage.statusActivity.isOnlineAndIdle'}
    }
}
